// extracted by mini-css-extract-plugin
export default {"settings-layout__title":"settings-layout_settings-layout__title__YfV2O","settings-layout__menu":"settings-layout_settings-layout__menu__+uLvH"};